module.exports = __webpack_public_path__ + "media/images/icons/form-created-237adc4dcee3f7aa449a5b3dedc09bfa.svg";